export default __webpack_public_path__ + "static/media/Promo.e6976756.png";